module.exports = __webpack_public_path__ + "img/aqtobe4.15595ff6.jpg";